import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { useSessionStore } from '../stores/session'
import type { Workspace } from '../types'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/callback',
      name: 'callback',
      component: () => import('../views/CallbackView.vue'),
      meta: { public: true },
    },
    {
      path: '/select-workspace',
      name: 'select-workspace',
      component: () => import('../views/SelectWorkspaceView.vue'),
    },
    {
      path: '/',
      component: () => import('../views/AppLayout.vue'),
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('../views/HomeView.vue'),
        },
        {
          path: 'documents',
          name: 'documents',
          component: () => import('../views/DocumentsView.vue'),
        },
        {
          path: 'documents/:id',
          name: 'document-detail',
          component: () => import('../views/DocumentDetailView.vue'),
        },
      ],
    },
  ],
})

router.beforeEach(async (to) => {
  if (to.meta.public) return true

  const auth = useAuthStore()
  if (!auth.isAuthenticated) {
    const { login } = await import('../services/auth')
    await login()
    return false
  }

  const session = useSessionStore()
  if (!session.selectedSupply) {
    if (session.workspaces.length === 0) {
      const { api } = await import('../services/api')
      const realm = import.meta.env.VITE_OIDC_REALM
      const data = await api.get<Workspace[]>(
        `/login/realms/${realm}/custom-resources/suppliers`,
      )
      session.setWorkspaces(data)

      if (data.length === 1) {
        session.selectWorkspace(data[0])
        if (data[0].supplies.length === 1) {
          session.selectSupply(data[0].supplies[0])
          return { name: 'home' }
        }
      }
    }

    if (to.name !== 'select-workspace') {
      return { name: 'select-workspace' }
    }
  }

  return true
})

export default router
